module.exports = __webpack_public_path__ + "static/media/baratheon_power.eaf1895c.png";